import { render } from "./Iframe.vue?vue&type=template&id=1a0f1de7&scoped=true"
import script from "./Iframe.vue?vue&type=script&lang=js"
export * from "./Iframe.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./Iframe.vue?vue&type=style&index=1&id=1a0f1de7&lang=css"
import "./Iframe.vue?vue&type=style&index=2&id=1a0f1de7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0f1de7"]])

export default __exports__